import Svg, { Path, SvgProps } from 'react-native-svg'
import { useWindowDimensions } from '../../util/util'

const Arc = (props: SvgProps) => {
  const width = useWindowDimensions()
  return (
    <Svg {...props} width={width} height={'100%'} viewBox={`0 0 ${width} 162.086`}>
      <Path d={`M0 0h${width}v40.646s-294.669 121.439-720 121.439S0 40.646 0 40.646z`} fill="#24397a" />
    </Svg>
  )
}

export { Arc }
